export const iconFontAwesomeBuildingsMonument = (
	<i className="fa-solid fa-monument"></i>
);
